import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Who We Serve", href: "#built-for" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Founder", href: "#founder" },
  { label: "Work", href: "#work" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
const [open, setOpen] = useState(false);
const [showNav, setShowNav] = useState(true);

  useEffect(() => {
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    setScrolled(currentScrollY > 20);

    if (currentScrollY <= 50) {
      setShowNav(true);
    } else if (currentScrollY > lastScrollY) {
      setShowNav(false);
    } else {
      setShowNav(true);
    }

    lastScrollY = currentScrollY;
  };

window.addEventListener("scroll", handleScroll);

return () => window.removeEventListener("scroll", handleScroll);
}, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
  showNav ? "translate-y-0" : "-translate-y-full"
} ${
  scrolled
    ? "bg-[#1A2238]/90 backdrop-blur-xl border-b border-[#FAF7F2]/10"
    : "bg-transparent"
}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <a
  href="#top"
  data-testid="nav-logo"
  className="flex items-center"
>
  <img
    src="/Logo.svg"
    alt="DOMINATE"
    className="h-24 w-auto"
  />
</a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="link-underline text-sm font-semibold text-[#FAF7F2]/80 hover:text-[#FAF7F2] py-1"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="https://cal.com/raj-rakshit-ssudkn"
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center bg-[#FF6A3D] text-[#FAF7F2] font-bold text-sm py-3 px-6 transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(255,106,61,0.4)]"
        >
          Connect with us
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#FAF7F2] p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-[#1A2238] border-t border-[#FAF7F2]/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
  {links.map((l) => (
    <a
      key={l.href}
      href={l.href}
      onClick={() => {
        setOpen(false);

        setTimeout(() => {
          document.querySelector(l.href)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 200);
      }}
      className="text-base font-semibold text-[#FAF7F2]/85"
    >
      {l.label}
    </a>
  ))}

  <a
    href="https://cal.com/raj-rakshit-ssudkn"
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => setOpen(false)}
    className="bg-[#FF6A3D] text-[#FAF7F2] font-bold py-3 px-6 text-center rounded-full"
  >
    Connect with us
  </a>
</div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
